import { render, staticRenderFns } from "./QuizSection.vue?vue&type=template&id=27fb88f4&scoped=true"
import script from "./QuizSection.vue?vue&type=script&lang=js"
export * from "./QuizSection.vue?vue&type=script&lang=js"
import style0 from "./QuizSection.vue?vue&type=style&index=0&id=27fb88f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fb88f4",
  null
  
)

export default component.exports